import React, { useState } from "react";
import "./Orders.css";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import "@progress/kendo-theme-default/dist/all.css";
import { Container, Row, Col } from "react-bootstrap";
import Sidebar from "../../components/SidebarQA/Sidebar";
import { SearchFilter } from "../../components/SearchFilter/SearchFilter";
import * as GrIcons from "react-icons/gr";
import { DataLoader } from "../../utils/DataLoader";
import { useEffect } from "react";
import { GetOrderStatus } from "../../apis/MiscAPI";
import { useSelector } from "react-redux";

export default function Orders() {
  const {user} = useSelector((state) => state.auth);
  const ControllerNActionName = {
    ControllerName: "Order",
    ActionName: "getallorders",
    SearchField: "order_id",
    MandatoryField: "qa_id",
  };
  const [orders, setOrders] = useState({
    data: [],
    total: 77,
  });
  const [dataState, setDataState] = useState({
    take: 50,
    skip: 0,
    filter: "0",
    mandatoryField: user.userid,
  });
  const dataStateChange = (e) => {
    setDataState(e.dataState);
  };
  const dataReceived = (orders) => {
    setOrders(orders);
  };
  const initialSort = [
    {
      field: "isnull(order_update_timestamp,order_timestamp)",
      dir: "desc",
    },
  ];
  const [count, setCount] = useState(1);
  const [sort, setSort] = React.useState(initialSort);
  const [orderStatuses, setOrderStatuses] = useState([]);

  const handleSorting = (e) => {
    localStorage.setItem("sortData", true);
    let sortingArray = e.sort;
    sortingArray.forEach((element, i) => {
      if (element.field === "orderId") {
        e.sort[i].field = "order_id";
        e.sort[i].dir = count % 2 === 0 ? "desc" : "asc";
      } else if (element.field === "customerName") {
        e.sort[i].field = "order_customer_name";
        e.sort[i].dir = count % 2 === 0 ? "desc" : "asc";
      } else if (element.field === "requestorName") {
        e.sort[i].field = "requestor_name";
        e.sort[i].dir = count % 2 === 0 ? "desc" : "asc";
      } else if (element.field === "applicantName") {
        e.sort[i].field = "order_applicant_name";
        e.sort[i].dir = count % 2 === 0 ? "desc" : "asc";
      } else if (element.field === "completionDate") {
        e.sort[i].field = "order_end_date";
        e.sort[i].dir = count % 2 === 0 ? "desc" : "asc";
      }
    });
    setCount(count + 1);
    setSort(e.sort);
  };
  const handleSearch = async (searchValue) => {
    localStorage.setItem("searchData", true);
    setDataState({
      take: 50,
      skip: 0,
      filter: searchValue,
      mandatoryField: user.userid,
    });
  };
  const handleAdvanceSearch = async (searchData) => {
    let submissionSearch = false;
    let completionSearch = false;
    if (
      searchData.submissionStartDate !== "" &&
      searchData.submissionEndDate !== ""
    )
      submissionSearch = true;
    if (
      searchData.completionStartDate !== "" &&
      searchData.completionEndDate !== ""
    )
      completionSearch = true;

    let searchBody = {
      isAdvanceSearch: "yes",
      submission_start_date:
        submissionSearch === true ? searchData.submissionStartDate : "",
      submission_end_date:
        submissionSearch === true ? searchData.submissionEndDate : "",
      completion_start_date:
        completionSearch === true ? searchData.completionStartDate : "",
      completion_end_date:
        completionSearch === true ? searchData.completionEndDate : "",
      applicant_name: searchData.applicantName,
      status:
        searchData.orderStatus.statusId === 0
          ? ""
          : searchData.orderStatus.statusId,
    };
    localStorage.setItem("searchData", true);
    setDataState({
      take: 50,
      skip: 0,
      filter: searchBody,
      mandatoryField: user.userid,
    });
  };
  useEffect(() => {
    async function GetOrderStatuses(){
      var result = await GetOrderStatus();
      setOrderStatuses(result.data);
    }
    GetOrderStatuses();
  },[]);

  return (
    <>
      <Container fluid>
        <Row>
          <div className="admin-wrapper">
            <div className="left-section">
              <Sidebar />
            </div>
            <div className="right-section">
              <Container fluid>
                <Row className="admin-page-row orders">
                  <Col lg={6} md={6} sm={12}>
                    <div className="page-title">
                      <h2>Orders</h2>
                    </div>
                  </Col>
                  <Col lg={6} md={6} sm={12}>
                    <div className="search-filter">
                      <SearchFilter
                        search={handleSearch}
                        advSearch={handleAdvanceSearch}
                        investigatorid={user.userid}
                        orderStatuses={orderStatuses}
                        requestorid="0"
                        displayShort={false}
                      />
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col className="order-list">
                    <Grid
                      sortable={true}
                      sort={sort}
                      onSortChange={(e) => {
                        handleSorting(e);
                      }}
                      pageable={true}
                      {...dataState}
                      className="investi-order-table"
                      style={{ height: "70vh" }}
                      data={orders}
                      onDataStateChange={dataStateChange}
                      resizable={true}
                    >
                      <GridColumn
                        field="id"
                        title="Order No."
                        width="100px"
                        minResizableWidth={30}
                      />
                      <GridColumn
                        field="orderStartDate"
                        title="Date"
                        width="120px"
                        minResizableWidth={100}
                      />
                      <GridColumn
                        field="orderCustomerName"
                        title="Customer"
                        width="100%"
                        minResizableWidth={120}
                      />
                      <GridColumn
                        field="requestorName"
                        title="Requestor"
                        width="100%"
                        minResizableWidth={150}
                      />
                      <GridColumn
                        field="orderApplicantName"
                        title="Applicant"
                        width="100%"
                        minResizableWidth={120}
                      />
                      <GridColumn
                        field="orderPo"
                        title="RE/PO Number"
                        width="100%"
                        minResizableWidth={140}
                      />
                      <GridColumn
                        field="reportsName"
                        title="Report"
                        width="100%"
                        minResizableWidth={120}
                      />
                      <GridColumn
                        field="orderStatusName"
                        title="Order Status"
                        width="100px"
                      />
                      <GridColumn
                        field="id"
                        title="Action"
                        width="100px"
                        cell={(props) => (
                          <td>
                            <a
                              href={
                                "/qa/OrderDetails?id=" +
                                props.dataItem.id
                              }
                            >
                              <GrIcons.GrFormView />
                            </a>
                          </td>
                        )}
                      ></GridColumn>
                    </Grid>
                    <DataLoader
                      dataState={dataState}
                      onDataReceived={dataReceived}
                      dataItem={ControllerNActionName}
                      dataSort={sort}
                    />
                  </Col>
                </Row>
              </Container>
            </div>
          </div>
        </Row>
      </Container>
    </>
  );
}
